import { Injectable } from '@angular/core'
import { ConversationTypes } from 'shared-lib'
import { EmployerApplicationConversationProvider } from './application-conversation-config.provider'

@Injectable({ providedIn: 'root' })
export class EmployerApplicationConversationDMProvider extends EmployerApplicationConversationProvider {
  conversationType = ConversationTypes.JobApplicationDM
}
